import { render, staticRenderFns } from "./ClientDetailCard.vue?vue&type=template&id=7e7659d0&scoped=true&"
import script from "./ClientDetailCard.vue?vue&type=script&lang=js&"
export * from "./ClientDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailCard.vue?vue&type=style&index=0&id=7e7659d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7659d0",
  null
  
)

export default component.exports